/* eslint-disable @typescript-eslint/naming-convention */
export class LoginResponse {
	public Data: string;
	public Errors: string[];
	public Tokens: {
		AccessToken: string;
		RefreshToken: string;
	  };
}
